import FacultyGrid from '@components/sections/FacultyGrid'
import { JsonLd } from '../../components/seo/JsonLd'
import { serviceSchemas, breadcrumbSchema } from '../../data/schemaData'
import styles from './OurServices.module.css'

const OurServices = () => {
  const serviceBreadcrumb = breadcrumbSchema([
    { name: "Home", url: "https://nikketengg.com/" },
    { name: "Our Services" }
  ]);

  return (
    <div className={styles.ourServices}>
      <JsonLd data={serviceBreadcrumb} />
      {serviceSchemas.map((schema, i) => (
        <JsonLd key={i} data={schema} />
      ))}
      <FacultyGrid />
    </div>
  )
}

export default OurServices
